module.exports = __webpack_public_path__ + "img/Samoa.7413db6a.gif";